import { BoxIcon, Text } from '#atoms';

import {
  CoachInformation,
  LabelBox,
  CoachShortsIntro
} from '#templates/CoachDetailContent/DetailInfo/CoachIntroduce/styles';
import { Link } from 'react-router-dom';
import EmptyContent from 'src/refactor_shared/ui/empty-content';

const Introduce = ({
  introduction,
  shortIntroduction
}: {
  shortIntroduction?: string;
  introduction?: string;
}) => {
  return (
    <CoachInformation>
      <LabelBox>
        <Text textStyle="t3">소개글</Text>
        <Link to="/profile/introduce">
          <BoxIcon type="edit-sharp" onlyIcon size={20} />
        </Link>
      </LabelBox>
      {shortIntroduction || introduction ? (
        <>
          <CoachShortsIntro>
            <p className="grey">"</p>
            <p>{shortIntroduction}</p>
            <p className="grey">"</p>
          </CoachShortsIntro>
          <Text
            textColor="gray2"
            style={{ whiteSpace: 'pre-line', color: '#C9C7D1' }}
          >
            {introduction ? introduction : ''}
          </Text>
        </>
      ) : (
        <EmptyContent>소개글이 없습니다</EmptyContent>
      )}
    </CoachInformation>
  );
};

export default Introduce;
